import React, { useEffect, useState } from 'react';
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import '../CSS/Global.css'; // Ensure your CSS file path is correct
import { useNavigate, useParams } from 'react-router-dom';
import productadd from "../Images/productadd.png"
import { useToast } from '@chakra-ui/react';
import { validateImageFileForUpload, IMAGE_ACCEPT_ATTR, IMAGE_TYPES_HELPER_TEXT } from "../utils/imageUploadRules";

const EditProduct = () => {
    const [productName, setProductName] = useState('');
    const [mrp, setMrp] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [shortDescription, setShortDescription] = useState('');
    const [image, setImage] = useState();
    const login = JSON.parse(localStorage.getItem("login")) || "";
    let navigate = useNavigate();
    const { id } = useParams();
    const [shiftHour, setShiftHour] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('');
    const [quantity, setSelectedQuantity] = useState('');
    const [units, setUnits] = useState([]);
    const url = getApiBaseUrl()
    const toast = useToast();

    console.log(id);

    const handleImageUpload = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = "";
        if (!file) return;
        const r = await validateImageFileForUpload(file);
        if (!r.ok) {
            toast({
                title: "Invalid image",
                description: r.message,
                status: "error",
                duration: 6000,
                isClosable: true,
                position: "top",
            });
            return;
        }
        setImage(r.file);
    };

    // Add form submission logic here

    const fetchDataProduct = async () => {
        try {
            const response = await fetch(`${url}/product/getsingleproduct/${id}`)
            const res = await response.json();
            setProductName(res.product_name);
            setShiftHour(res.shift_hour || '');
            setSellingPrice(res.sell_price);
            setMrp(res.mrp_price);
            setShortDescription(res.description);
            setImage(res.product_image);
            setSelectedQuantity(res.quantity);
            setSelectedUnit(res.unit)
        } catch (error) {
            console.log(error);
        }
    }

    console.log(image)
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Create FormData object to send image along with other data
        const formData = new FormData();
        formData.append('product_image', image);
        formData.append('product_name', productName);
        formData.append('mrp_price', mrp);
        formData.append('sell_price', sellingPrice);
        formData.append('quantity', quantity);
        formData.append('unit', selectedUnit);
        formData.append('description', shortDescription);
        formData.append('user_id', login.permanent_ID);
        formData.append('user_name', login.name);
        formData.append('shift_hour', shiftHour);

        try {
            // Replace with your backend API URL
            const response = await fetch(`${url}/product/change-product/${id}`, {
                method: 'PUT',
                body: formData,
            });

            const result = await response.json();
            console.log('Image uploaded:', result);
            if (response.ok) {
                navigate(-1)
            }
        } catch (error) {
            console.log('Error uploading image:', error);
        }
        console.log({
            productName,
            mrp,
            sellingPrice,
            shortDescription,
        });
    };

    const [category, setCategory] = useState();

    const fetchDataUser = async () => {
        try {
            const response = await fetch(`${getApiBaseUrl()}/store/getstorelist/mystore/${login.permanent_ID}`);
            const store = await response.json();
            console.log(store);
            setCategory(store.category)
        } catch (error) {
            console.log(error);
        }
    }


    const fetchCategory = async () => {
        try {
            const response = await fetch(`${getApiBaseUrl()}/category/singlecategory/${category}`);
            const res = await response.json();
            // Parse the units field
            if (res.units) {
                const parsedUnits = JSON.parse(res.units);
                setUnits(parsedUnits);
            } else {
                console.log('Units field is not available');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const hours = Array.from({ length: 24 }, (_, i) => {
        const value = i + 1;
        return {
            value,
            label: value.toString().padStart(2, '0') + ' hrs'
        };
    });

    useEffect(() => {
        if (category) {
            fetchCategory();
        }
    }, [category]);

    useEffect(() => {
        fetchDataProduct();
        fetchDataUser();
    }, [])

    return (
        <div className="product-container">
            <div className="product-image-column">
                <img
                    src={productadd}
                    alt="Product"
                    className="product-image"
                />
            </div>
            <div className="product-form-column">
                <h2>List Your Product/Skills/Service</h2>
                <form onSubmit={handleSubmit}>
                    <div className="product-form-group">
                        <label>Title:</label>
                        <input
                            type="text"
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                            placeholder="Enter Title"
                            required
                        />
                    </div>
                    <div className="product-form-group">
                        <label>Upload Image:</label>
                        <input
                            type="file"
                            accept={IMAGE_ACCEPT_ATTR}
                            onChange={handleImageUpload}
                        />
                        <p className="small text-muted" style={{ marginTop: 6 }}>{IMAGE_TYPES_HELPER_TEXT}</p>
                        <div>
                            <img className='imageeditproductmain' src={`${url}/${image}`} />
                        </div>
                    </div>
                    <div className="product-form-group">
                        <label>Short Description (max 50 chars):</label>
                        <input
                            type="text"
                            value={shortDescription}
                            onChange={(e) => setShortDescription(e.target.value)}
                            maxLength="50"
                            placeholder="Enter short description"
                            required
                        />
                    </div>
                    <div className="product-form-group">
                        <label>Hourly Shift:</label>
                        <select
                            className="bestselecttagforec"
                            value={shiftHour}
                            onChange={(e) => setShiftHour(e.target.value)}
                        >
                            <option value="">Select Hours</option>
                            {hours.map((hour) => (
                                <option key={hour.value} value={hour.value}>
                                    {hour.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="price-container">
                        <div className="product-form-group">
                            <label>Unit:</label>
                            <select
                                className='bestselecttagforec'
                                value={selectedUnit}
                                onChange={(e) => setSelectedUnit(e.target.value)}

                            >
                                <option value="">Select Unit</option>
                                {units.map((unit, index) => (
                                    <option key={index} value={unit}>
                                        {unit}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="product-form-group">
                            <label>Quantity/Value {selectedUnit === "" ? null : ("(" + selectedUnit + ")")}:</label>
                            <input
                                type="quantity"
                                value={quantity}
                                onChange={(e) => setSelectedQuantity(e.target.value)}
                                placeholder={`Enter Value in ${selectedUnit}`}

                            />
                        </div>

                    </div>


                    <div className="price-container">
                        <div className="product-form-group">
                            <label>MRP:</label>
                            <input
                                type="number"
                                value={mrp}
                                onChange={(e) => setMrp(e.target.value)}
                                placeholder="Enter MRP"

                            />
                        </div>
                        <div className="product-form-group">
                            <label>Offer Price:</label>
                            <input
                                type="number"
                                value={sellingPrice}
                                onChange={(e) => setSellingPrice(e.target.value)}
                                placeholder="Enter Offer Price"

                            />
                        </div>
                    </div>
                    <button type="submit" className="product-submit-button">Edit Product</button>
                </form>
            </div>
        </div>
    );
};

export default EditProduct;
